import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    InputNumber,
    notification,
    Radio,
    Row,
    Select,
} from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
    editClientApi,
    listOfCityApi,
    listOfCountryApi,
    listOfStateApi,
    updateClientApi,
} from '../../../../../config/Api'
import {
    API_ERR_MESSAGE,
    CHARACTER_PATTERN,
    CHARACTER_PATTERN_MESSAGE,
    NUMBER_AND_FRACTIONAL_PATTERN,
    NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE,
    PHONE_PATTERN,
    CALL_TIME_SEPARATOR,
    CALL_TIME_SLOTS,
} from '../../../../../config/constant'
import {
    ageFromDob,
    DOB_INPUT_FORMATS,
    formatDobForApi,
    isDobOutOfRange,
    parseDob,
    formatDobTyping,
    parseTypedDob,
} from '../../../../../services/BirthDate'
import { blockNonDigitKeys } from '../../../../../services/InputKeys'
import {
    cmToFeetInch,
    feetInchToCm,
    formatFeetInch,
    HEIGHT_LIMITS,
    parseStoredHeight,
} from '../../../../../services/Height'
import { BmiLevelTags } from '../../../../../components/BmiLevelTags'
import { isNewPlace, newPlaceName, PlaceSelect } from './PlaceSelect'

export const PersonalDetails = (props) => {
    const [form] = Form.useForm()
    const { Option } = Select
    const { id } = useParams()

    const [patientData, setPatientData] = useState()

    const [inputValueOfFt, setInputValueOfFt] = useState('')
    const [inputValueOfInch, setInputValueOfInch] = useState('')
    const [inputValueOfWeight, setInputValueOfWeight] = useState(50)
    const [inputValueOfHeight, setInputValueOfHeight] = useState('')
    const [heightUnit, setHeightUnit] = useState('feet')
    const [heightConversionValue, setheightConversionValue] = useState(0)

    const [heightInInch, setheightInInch] = useState(0)
    const [heightInCm, setheightInCm] = useState(0)

    const [selectedCountry, setSelectedCountry] = useState('')
    const [selectedCity, setSelectedCity] = useState()
    const [selectedState, setSelectedState] = useState()

    // country / state / city lists from the master data (Master Menu > Patient)
    const [countries, setCountries] = useState([])
    const [allStates, setAllStates] = useState([])
    const [allCities, setAllCities] = useState([])

    const [nutritionistType, setNutritionistType] = useState('')

    const [bmiValue, setBmiValue] = useState()

    // date of birth picker opens on the year list so a birth year is quick to reach
    const [dobPanelMode, setDobPanelMode] = useState('year')
    const dobValue = Form.useWatch('date_of_birth', form)
    const dobAge = ageFromDob(dobValue)

    // each dropdown only lists what belongs to the one above it
    const stateOption = allStates.filter((option) => option.country_id == selectedCountry)
    const citiesOption = allCities.filter((option) => option.state_id == selectedState)

    // dropdowns list places alphabetically
    const sortByName = (list) => [...(list || [])].sort((a, b) => (a.name || '').localeCompare(b.name || ''))

    // Api call for country, state and city list dropdown options
    const getListOfCountries = () => {
        listOfCountryApi()
            .then((res) => {
                if (res.status === 200) {
                    setCountries(sortByName(res.data.data))
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }

    // get the list of alll available states
    const getListOfStates = () => {
        listOfStateApi()
            .then((res) => {
                if (res.status === 200) {
                    setAllStates(sortByName(res.data.data))
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }

    // get the list of all acailable cities
    const getListOfCities = () => {
        listOfCityApi()
            .then((res) => {
                if (res.status === 200) {
                    setAllCities(sortByName(res.data.data))
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }

    useEffect(() => {
        let NutritionistType = JSON.parse(localStorage.getItem('user'))
        console.log('NutritionistType', NutritionistType)
        // setNutritionistType(NutritionistType?.type_of_account)
        setNutritionistType(NutritionistType?.user?.type_of_account)
    }, [])

    // load the country / state / city lists once
    useEffect(() => {
        getListOfCountries()
        getListOfStates()
        getListOfCities()
    }, [])

    // height and bmi calculation
    useEffect(() => {
        let currentHeightCm = 0
        let currentHeightFeetStr = ''

        const hasFeet =
            inputValueOfFt !== '' &&
            inputValueOfFt !== undefined &&
            inputValueOfFt !== null
        const hasInch =
            inputValueOfInch !== '' &&
            inputValueOfInch !== undefined &&
            inputValueOfInch !== null
        const hasHeight =
            inputValueOfHeight !== '' &&
            inputValueOfHeight !== undefined &&
            inputValueOfHeight !== null

        if (heightUnit === 'feet') {
            if (!hasFeet && !hasInch) {
                setheightInCm('')
                setheightInInch('')
                setheightConversionValue({ cm: '', feet: '' })
                setBmiValue(0)
                return
            }
            // whole feet and inches only
            const ft = Math.round(parseFloat(inputValueOfFt) || 0)
            const inch = Math.round(parseFloat(inputValueOfInch) || 0)

            // exact cm is kept for BMI, the shown cm is rounded to a whole number
            currentHeightCm = feetInchToCm(ft, inch)
            const cmVal = String(Math.round(currentHeightCm))

            // Sync the passive CM values
            if (heightInCm !== cmVal) setheightInCm(cmVal)
            if (String(inputValueOfHeight) !== cmVal) setInputValueOfHeight(cmVal)

            // Sync the active Feet string for API
            const feetStr = `${ft}.${inch}`
            if (heightInInch !== feetStr) setheightInInch(feetStr)

            currentHeightFeetStr = formatFeetInch({ ft, inch })
        } else {
            if (!hasHeight) {
                setheightInCm('')
                setheightInInch('')
                setheightConversionValue({ cm: '', feet: '' })
                setBmiValue(0)
                return
            }
            // whole cm only
            currentHeightCm = Math.round(parseFloat(inputValueOfHeight) || 0)

            // cm to whole feet and inches (never "5 ft 12 in")
            const { ft, inch } = cmToFeetInch(currentHeightCm)

            // Sync the passive Feet values
            const feetStr = `${ft}.${inch}`
            if (heightInInch !== feetStr) setheightInInch(feetStr)
            if (parseFloat(inputValueOfFt || 0) !== ft) setInputValueOfFt(ft)
            if (parseFloat(inputValueOfInch || 0) !== inch)
                setInputValueOfInch(inch)

            // Sync the active CM string for API
            const cmVal = String(currentHeightCm)
            if (heightInCm !== cmVal) setheightInCm(cmVal)

            currentHeightFeetStr = formatFeetInch({ ft, inch })
        }

        setheightConversionValue({
            cm: Math.round(currentHeightCm),
            feet: currentHeightFeetStr,
        })

        // BMI calculation: weight (kg) / height (m)^2
        if (currentHeightCm > 0 && inputValueOfWeight > 0) {
            const heightInMeter = currentHeightCm / 100
            const bmi = inputValueOfWeight / (heightInMeter * heightInMeter)
            setBmiValue(bmi.toFixed(2))
        } else {
            setBmiValue(0)
        }
    }, [
        inputValueOfFt,
        inputValueOfInch,
        inputValueOfHeight,
        inputValueOfWeight,
        heightUnit,
    ])

    // get the available details of patient
    const getDetailsOfPatient = () => {
        editClientApi(id)
            .then((res) => {
                if (res.status === 200) {
                    setPatientData(res.data.data)
                    // console.log(res.data.data);
                    let data = res.data.data
                    // if (patientData) {
                    // console.log(data);
                    form.setFieldsValue({
                        patient_name: data?.name,
                        date_of_birth: parseDob(data?.dob),
                        activity: data?.activity || '',
                        preferred_call_time: data?.preferred_call_time ? data.preferred_call_time.split(CALL_TIME_SEPARATOR) : [],
                        gender: data?.gender,
                        // 'height': data?. ,
                        weight: data?.weight,
                        phenotype:
                            data && data?.hasOwnProperty('phenotype')
                                ? data?.phenotype
                                : '',
                        phone: data?.mobile || '',
                        country: data?.country_id || '',
                        state: data?.state_id || '',
                        city: data?.city_id || '',
                    })
                    // stored height as whole-number inputs (older decimal values are rounded)
                    const storedHeight = parseStoredHeight(data?.height_inch, data?.height_cm)
                    setHeightUnit(storedHeight.unit)
                    setInputValueOfFt(storedHeight.ft)
                    setInputValueOfInch(storedHeight.inch)
                    setInputValueOfHeight(storedHeight.cm)
                    setBmiValue(data?.bmi || 0)
                    setInputValueOfWeight(data?.weight || 0)
                    setSelectedCountry(data?.country_id || 0)
                    setSelectedCity(data?.city_id || 0)
                    setSelectedState(data?.state_id || 0)
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }

    useEffect(() => {
        // getDetailsOfPatient()

        if (props?.patientData) {
            // console.log(props?.patientData);
            setPatientData(props?.patientData)
            let data = props?.patientData
            form.setFieldsValue({
                patient_name: data?.name,
                date_of_birth: parseDob(data?.dob),
                activity: data?.activity || '',
                gender: data?.gender,
                // 'height': data?. ,
                weight: data?.weight,
                phenotype:
                    data && data?.hasOwnProperty('phenotype')
                        ? data?.phenotype
                        : '',
                phone: data?.mobile || '',
                country: data?.country_id || '',
                state: data?.state_id || '',
                city: data?.city_id || '',
            })
            // stored height as whole-number inputs (older decimal values are rounded)
            const storedHeight = parseStoredHeight(data?.height_inch, data?.height_cm)
            setHeightUnit(storedHeight.unit)
            setInputValueOfFt(storedHeight.ft)
            setInputValueOfInch(storedHeight.inch)
            setInputValueOfHeight(storedHeight.cm)
            setBmiValue(data?.bmi || 0)
            setInputValueOfWeight(data?.weight || 0)
            setSelectedCountry(data?.country_id || 0)
            setSelectedCity(data?.city_id || 0)
            setSelectedState(data?.state_id || 0)
        }

    }, [props?.patientData])

    // a patient without a country starts with India selected
    // (after the effect above, which fills the form with the patient's saved values)
    useEffect(() => {
        if (!countries.length || form.getFieldValue('country')) return
        const india = countries.find((country) => country.name?.trim().toLowerCase() === 'india')
        if (india) {
            form.setFieldValue('country', india.id)
            setSelectedCountry(india.id)
        }
    }, [countries, props?.patientData])

    const onHeightUnitChange = (unitValue) => {
        setHeightUnit(unitValue)
    }
    const onInchChange = (newValue) => {
        setInputValueOfInch(newValue)
    }
    const onWeightChange = (newValue) => {
        setInputValueOfWeight(newValue)
    }
    const onFinish = (values) => {
        const data = {
            // this page form data
            name: values?.patient_name,
            dob: formatDobForApi(values.date_of_birth),
            activity: values.activity,
            // kept in the order of the day, not the order they were picked
            preferred_call_time: CALL_TIME_SLOTS.filter((slot) => (values.preferred_call_time || []).includes(slot)).join(CALL_TIME_SEPARATOR),
            gender: values.gender,
            // null when not picked: these are number columns, so an empty string can't be saved
            // a typed-in place goes as a name and the server finds or adds it
            country_id: isNewPlace(values.country) ? null : values.country || null,
            state_id: isNewPlace(values.state) ? null : values.state || null,
            city_id: isNewPlace(values.city) ? null : values.city || null,
            country_name: newPlaceName(values.country),
            state_name: newPlaceName(values.state),
            city_name: newPlaceName(values.city),
            height_inch: heightUnit === 'feet' ? heightInInch : '',
            height_cm: heightUnit === 'cm' ? inputValueOfHeight : '',
            weight: values.weight,
            bmi: bmiValue,
            mobile: values.phone,
            phenotype: values.phenotype ? values.phenotype : '',

            // client detail page data
            email: patientData?.email,
            end_date: patientData?.end_date,
            program_id: patientData?.program_id,
            start_date: patientData?.start_date,
            whatsapp_number: patientData?.whatsapp_number,
        }
        updateClientApi(id, data)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: res.data.message || 'Patient Detail Update successfully',
                    })
                    // places added by this save are in the master lists now
                    getListOfCountries()
                    getListOfStates()
                    getListOfCities()
                    getDetailsOfPatient()
                    props.onSaved && props.onSaved()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }
    const resetData = () => {
        form.resetFields()
    }
    return (
        <div className="client-detail-tab-content">
            <Form
                name="personalDetail"
                className="addpersonalDetailForm"
                form={form}
                onFinish={onFinish}
            >
                <Row
                    gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]}
                    className="mt-3"
                >
                    <Col xs={24} md={16} xl={8} xxl={8}>
                        <label className="form-input-label">
                            Name
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="patient_name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Enter Name!',
                                },
                                {
                                    pattern: CHARACTER_PATTERN,
                                    message: CHARACTER_PATTERN_MESSAGE,
                                },
                            ]}
                        >
                            <Input
                                placeholder="Enter Name"
                                className="mt-2 p-2"
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={8} xxl={8}>
                        <label className="form-input-label">
                            Date of Birth
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="date_of_birth"
                            className="mb-0"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Enter BirthDate!',
                                },
                                {
                                    validator: (_, value) =>
                                        isDobOutOfRange(value)
                                            ? Promise.reject(new Error('Please enter a valid birth date!'))
                                            : Promise.resolve(),
                                },
                            ]}
                        >
                            <DatePicker
                                // no future dates and nothing older than 100 years
                                disabledDate={isDobOutOfRange}
                                // typing accepts DD-MM-YYYY, DD/MM/YYYY, DD.MM.YYYY and DDMMYYYY
                                format={DOB_INPUT_FORMATS}
                                placeholder="DD-MM-YYYY"
                                // "05081989" is shown as "05-08-1989" while typing
                                inputRender={(inputProps) => (
                                    <input
                                        {...inputProps}
                                        onChange={(e) => {
                                            e.target.value = formatDobTyping(e.target.value)
                                            inputProps.onChange(e)
                                        }}
                                    />
                                )}
                                // keep a typed date when leaving the field with Tab or a click, not only with Enter
                                onBlur={(e) => {
                                    const typed = parseTypedDob(e.target.value)
                                    const current = form.getFieldValue('date_of_birth')
                                    if (typed && !(current && typed.isSame(current, 'day'))) {
                                        form.setFieldsValue({ date_of_birth: typed })
                                        form.validateFields(['date_of_birth'])
                                    }
                                }}
                                mode={dobPanelMode}
                                onPanelChange={(_, mode) => setDobPanelMode(mode)}
                                onOpenChange={(open) => open && setDobPanelMode('year')}
                                defaultPickerValue={moment().subtract(30, 'years')}
                                className="w-100 mt-2 p-2"
                            />
                        </Form.Item>
                        <p className="mt-1 mb-3 text-muted">
                            {dobAge !== null ? `Age: ${dobAge} years` : '\u00A0'}
                        </p>
                    </Col>
                    <Col xl={8}></Col>
                    <Col xs={24} md={16} xl={8} xxl={8}>
                        <label className="form-input-label">
                            Activity
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="activity"
                            rules={
                                [
                                    // { required: true, message: "Please select activity!" },
                                ]
                            }
                            initialValue=""
                        >
                            <Select
                                className="mt-2"
                                // value={regType}
                                // onChange={(e) => setRegType(e)}
                            >
                                <Option value="" disabled hidden>
                                    Select Activity
                                </Option>
                                <Option value="Sedentary">Sedentary</Option>
                                <Option value="Moderate">Moderate</Option>
                                <Option value="Heavy">Heavy</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={8} xxl={8}>
                        <label className="form-input-label">
                            Preferred Call Time
                        </label>
                        {/* shown on Appointments and when booking one */}
                        <Form.Item name="preferred_call_time" initialValue={[]}>
                            <Select
                                mode="multiple"
                                allowClear
                                className="mt-2"
                                placeholder="Select time slots"
                                maxTagCount="responsive"
                            >
                                {CALL_TIME_SLOTS.map((slot) => (
                                    <Option key={slot} value={slot}>{slot}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={8} xxl={8}>
                        <label className="form-input-label">
                            Gender
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="gender"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Select Gender!',
                                },
                            ]}
                        >
                            <Radio.Group className="mt-2 ">
                                <Radio value="Male"> Male</Radio>
                                <Radio value="Female">Female</Radio>
                                <Radio value="Other">Other</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col xl={8} />
                    <Col xl={8} className="text-start align-self-center">
                        <Form.Item
                            className="mb-0"
                            // rules={[{ required: true, message: "Please insert Height!" }]}
                            label={
                                <label className="form-input-label text-start">
                                    Height
                                    {/* <span className="asterik"> *</span> */}
                                </label>
                            }
                            name="height"
                        >
                            {/* <div className="d-flex">
                                <Input.Group compact className="inline-flex" style={{display:"contents"}}>
                                    <InputNumber
                                        className="ms-5"
                                        // min={2}
                                        // max={8}
                                        suffix="aa"
                                        style={{ margin: '0 2% 0 0' }}
                                        value={inputValueOfHeight}
                                        // step={0.01}
                                        // pattern={PHONE_PATTERN}
                                        onChange={setInputValueOfHeight}
                                    // className="text-center"
                                    />
                                    <span>
                                        {heightUnit ? "Cm" : "Feet" }
                                        </span> 
                                </Input.Group>
                                Cm<Switch className="mx-2" value={heightUnit} onChange={(e) => onHeightUnitChange(e)} />Feet
                            </div> */}
                            <Input.Group compact className="ms-5">
                                <Select
                                    value={heightUnit}
                                    onChange={(e) => onHeightUnitChange(e)}
                                >
                                    <Option value="cm">Cm</Option>
                                    <Option value="feet">Feet</Option>
                                </Select>
                                {heightUnit == 'feet' ? (
                                    <>
                                        {/* whole numbers only: feet 1-8, inch 0-11 */}
                                        <InputNumber
                                            style={{
                                                width: '20%',
                                            }}
                                            placeholder="Feet"
                                            className="py-1"
                                            value={inputValueOfFt}
                                            min={HEIGHT_LIMITS.feet.min}
                                            max={HEIGHT_LIMITS.feet.max}
                                            precision={0}
                                            controls={false}
                                            onKeyDown={blockNonDigitKeys}
                                            onChange={(e) =>
                                                setInputValueOfFt(e ?? '')
                                            }
                                        />
                                        <InputNumber
                                            placeholder="Inch"
                                            className="py-1"
                                            value={inputValueOfInch}
                                            min={HEIGHT_LIMITS.inch.min}
                                            max={HEIGHT_LIMITS.inch.max}
                                            precision={0}
                                            controls={false}
                                            onKeyDown={blockNonDigitKeys}
                                            onChange={(e) =>
                                                setInputValueOfInch(e ?? '')
                                            }
                                        />
                                    </>
                                ) : (
                                    <>
                                        {/* whole numbers only: 50-250 cm */}
                                        <InputNumber
                                            style={{
                                                width: '20%',
                                            }}
                                            placeholder="Cm"
                                            className="py-1"
                                            value={inputValueOfHeight}
                                            min={HEIGHT_LIMITS.cm.min}
                                            max={HEIGHT_LIMITS.cm.max}
                                            precision={0}
                                            controls={false}
                                            onKeyDown={blockNonDigitKeys}
                                            onChange={(e) =>
                                                setInputValueOfHeight(e ?? '')
                                            }
                                        />
                                    </>
                                )}
                            </Input.Group>
                        </Form.Item>

                        {/* <span>ft</span> */}
                        <br />
                        {/* <div className="d-flex justify-content-center w-100">

                            <span>2 ft</span>
                            <Slider
                                min={2}
                                max={8}
                                onChange={onFtChange}
                                value={typeof inputValueOfFt === 'number' ? inputValueOfFt : 0}
                                // step={0.01}
                                style={{ width: '80%' }}
                                className="align-self-center mx-4"
                            />
                            <span>8 ft</span>
                        </div> */}
                    </Col>
                    <Col xl={16}>
                        <div className="d-flex flex-column">
                            <label className="form-input-label">
                                Feet :{' '}
                                {heightConversionValue?.feet || '0 ft 0 in'}
                            </label>
                            <label className="form-input-label">
                                CM : {heightConversionValue?.cm || 0}
                            </label>
                        </div>
                    </Col>
                    {/*<Col xl={10} className="text-center align-self-center slider ms-2">
                        <InputNumber
                            min={0}
                            max={11}
                            style={{ margin: '0 2% 0 0' }}
                            value={inputValueOfInch}
                            // step={0.01}
                            onChange={onInchChange}
                        />
                        <span>inch</span>
                        <br />
                        <div className="d-flex justify-content-center w-100">

                            <span>0 inch</span>
                            <Slider
                                min={0}
                                max={11}
                                onChange={onInchChange}
                                value={typeof inputValueOfInch === 'number' ? inputValueOfInch : 0}
                                // step={0.01}
                                className="align-self-center mx-4"
                            />
                            <span>11 inch</span>
                        </div>
                    </Col> */}
                    {/* Height Slider  */}

                    {/* <Col xl={7} /> */}
                    {/* Weight Slider  */}

                    <Col
                        xl={24}
                        className="d-flex text-start align-items-center align-self-center"
                    >
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: 'Please insert Weight!',
                                },
                                {
                                    pattern: NUMBER_AND_FRACTIONAL_PATTERN,
                                    message:
                                        NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE,
                                },
                            ]}
                            label={
                                <label className="form-input-label text-start">
                                    Weight
                                    {/* <span className="asterik"> *</span> */}
                                </label>
                            }
                            name="weight"
                        >
                            <div className="d-flex">
                                <InputNumber
                                    className="ms-5 me-2"
                                    min={15}
                                    max={200}
                                    style={{ margin: '0 1% 0 0' }}
                                    value={inputValueOfWeight}
                                    // step={0.01}
                                    onChange={onWeightChange}
                                    controls={false}
                                />
                                Kgs
                            </div>
                        </Form.Item>
                        <br />
                        {/* <div className="d-flex justify-content-center w-100">
                            <span>15 Kgs</span>
                            <Slider
                                min={15}
                                max={200}
                                onChange={onWeightChange}
                                value={typeof inputValueOfWeight === 'number' ? inputValueOfWeight : 0}
                                // step={0.01}
                                style={{ width: '85%' }}
                                className="mx-4 align-self-center"
                            />
                            <span>200 Kgs</span>
                        </div> */}
                    </Col>
                    {/* Weight Slider Over*/}
                    {/* <Col xl={2} /> */}
                    <Col xs={2} md={16} xl={2} xxl={2}>
                        <label className="form-input-label">
                            BMI
                            {/* <span className="asterik"> *</span> */}
                        </label>
                    </Col>
                    <Col xs={22} md={16} xl={22} xxl={22}>
                        <div className="d-flex align-items-baseline">
                            <Form.Item name="bmi">
                                {parseFloat(bmiValue) || 0}
                            </Form.Item>
                            {/* obesity level on both scales */}
                            <span className="ms-3">
                                <BmiLevelTags bmi={bmiValue} />
                            </span>
                        </div>
                    </Col>
                    {/* <Col xs={2} md={16} xl={8} xxl={2} > */}
                    <Col xs={2} md={16} xl={8} xxl={8}>
                        {/*  only ayurvedic doctor has available phenotype option selection for patient    */}
                        <span
                            style={{
                                display:
                                    nutritionistType !==
                                        'Nutritionist (Ayurveda)' && 'none',
                            }}
                        >
                            <label className="form-input-label">
                                Phenotype
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item name="phenotype" initialValue="">
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select PhenoType
                                    </Option>
                                    <Option value="Kapha">Kapha</Option>
                                    <Option value="Pitta">Pitta</Option>
                                    <Option value="Vata">Vata</Option>
                                </Select>
                            </Form.Item>
                        </span>
                    </Col>
                    <Col xl={16} />
                    <Col xs={24} md={16} xl={8} xxl={8}>
                        <label className="form-input-label">
                            Phone
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="phone"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please insert Phone No!',
                                },
                                {
                                    pattern: PHONE_PATTERN,
                                    message: 'Please insert valid data!',
                                },
                            ]}
                        >
                            <Input
                                maxLength={10}
                                placeholder="Enter Phone No"
                                className="mt-2 p-2"
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={8} xxl={8}>
                        <label className="form-input-label">
                            Country
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="country"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Select Country!',
                                },
                            ]}
                        >
                            <PlaceSelect
                                options={countries}
                                placeholder="Select Country"
                                onChange={(e) => {
                                    setSelectedCountry(e)
                                    form.setFieldValue('state', '')
                                    form.setFieldValue('city', '')
                                    setSelectedState('')
                                    setSelectedCity('')
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xl={8}></Col>

                    <Col xs={24} md={16} xl={8} xxl={8}>
                        <label className="form-input-label">
                            State/Region
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="state"
                            rules={
                                [
                                    // { required: true, message: "Please Select State !" },
                                ]
                            }
                            initialValue=""
                        >
                            <PlaceSelect
                                options={stateOption}
                                placeholder="Select Region"
                                onChange={(e) => {
                                    setSelectedState(e)
                                    form.setFieldValue('city', '')
                                    setSelectedCity('')
                                }}
                                disabled={!selectedCountry}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={8} xxl={8}>
                        <label className="form-input-label">
                            City
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="city"
                            rules={[
                                {
                                    // only when the state has cities to pick from
                                    required: citiesOption.length > 0,
                                    message: 'Please Select City!',
                                },
                            ]}
                            initialValue=""
                        >
                            <PlaceSelect
                                options={citiesOption}
                                placeholder="Select City"
                                onChange={(e) => setSelectedCity(e)}
                                // a new city can be typed even when the state has none yet
                                disabled={!selectedState}
                            />
                        </Form.Item>
                    </Col>
                    {/* <Col xl={8}></Col> */}

                    {/* <Col xs={24} md={16} xl={8} xxl={8}>
                        <label className="form-input-label">
                            ZIP/PIN
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Zip/pin code!",
                                },
                                {
                                    pattern: PHONE_PATTERN,
                                    message: "Please insert valid data!",
                                },
                            ]}
                        >
                            <Input placeholder="Enter Name" className="mt-2 p-2" />
                        </Form.Item>
                    </Col> */}

                    <Col
                        xs={24}
                        md={16}
                        xl={24}
                        xxl={24}
                        className="text-center"
                    >
                        <Button
                            htmlType="submit"
                            className="submit-button b-0 px-5 rounded"
                        >
                            SAVE
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}
